import { jsxs as t, Fragment as x, jsx as s } from "react/jsx-runtime";
import { CurrencyBadge as a } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as m } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as p } from "../../../../../providers/use-locale-provider.mjs";
import { usePhysicalProductStore as d } from "../../../../../store/index.mjs";
import { getProductPriceWithQuantity as f } from "../../utils/get-product-price-with-quantity.mjs";
import { useTranslation as h, centsToUnits as o } from "@systemeio/ui";
const j = ({ product: e, calculatePrice: n }) => {
  const { locale: r } = p(), { quantity: i, productVariant: l } = d(), { t: c } = h();
  return e && e.name && /* @__PURE__ */ t(x, { children: [
    /* @__PURE__ */ t("div", { className: "flex w-full items-baseline justify-between gap-3", children: [
      /* @__PURE__ */ t("div", { className: "min-w-0 flex-1 text-[14px] leading-5", children: [
        /* @__PURE__ */ s("span", { children: e.name }),
        /* @__PURE__ */ t("span", { className: "ml-1 whitespace-nowrap font-bold", children: [
          "x",
          i
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex shrink-0 items-baseline gap-2.5", children: [
        /* @__PURE__ */ s(a, { currency: e.currency }),
        /* @__PURE__ */ s("span", { className: "text-[14px] font-semibold leading-5", children: m(
          o(
            f({
              calculatePrice: n,
              productVariant: l,
              product: e,
              quantity: i
            })
          ),
          e.currency,
          r
        ) })
      ] })
    ] }),
    !!(n != null && n.tax) && n.tax.rate > 0 && /* @__PURE__ */ t("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ s("span", { className: "text-[14px]", children: c("public_pages_purchase.vat_percent", {
        percent: n.tax.rate
      }) }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ s(a, { currency: e.currency }),
        /* @__PURE__ */ s("span", { className: "text-[14px] font-semibold", children: m(
          o(n.tax.amount),
          e.currency,
          r
        ) })
      ] })
    ] })
  ] });
};
export {
  j as Product
};
